import React, { useEffect, useState } from 'react'
import Text from 'antd/es/typography/Text'
import { Alert, Select, Space, Tooltip } from 'antd'
import { useFetchSubmissionVersionsQuery } from '../../../../../store/apis/submission.api'
import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import submissionSelectors from '../../../../../store/selectors/submission.selectors'
import userSelectors from '../../../../../store/selectors/user.selectors'
import { DEFAULT_SUBMISSION_VERSION, submissionActions } from '../../../../../store/slices/submission.slice'
import { sqlToJsDate } from '../../../../../utils/date.helper'
import { DislikeOutlined, LikeOutlined } from '@ant-design/icons'
import { errorColor, successColor } from '../../../../../constants/styles'
import { renderOptionWithDescription } from '../../../../../utils/antd.helper'

const SubmissionVersionSelector = () => {
    const openedSubmissionId = useSelector(submissionSelectors.openedSubmissionId)
    const selectedVersionId = useSelector(submissionSelectors.selectedVersionId)
    const isSenseUser = useSelector(userSelectors.isSenseUser)
    
    const dispatch = useDispatch()

    const { token, layerId } = useParams()

    const [versionsShouldBeFetched, setVersionsShouldBeFetched] = useState(false)
    const {
        data: submissionVersions,
        isFetching: isFetchingSubmissionVersions,
        error: errorFetchingSubmissionVersions,
    } = useFetchSubmissionVersionsQuery(
        { token, layerId, submissionId: openedSubmissionId },
        { skip: !versionsShouldBeFetched },
    )

    useEffect(() => {
        if (submissionVersions?.length) {
            dispatch(submissionActions.setSelectedVersionId(submissionVersions.at(-1).id))
        } else if (selectedVersionId !== DEFAULT_SUBMISSION_VERSION) {
            dispatch(submissionActions.setSelectedVersionId(DEFAULT_SUBMISSION_VERSION))
        }
    }, [submissionVersions])

    useEffect(() => {
        dispatch(submissionActions.setSelectedVersionId(DEFAULT_SUBMISSION_VERSION))
        setVersionsShouldBeFetched(false)
    }, [openedSubmissionId])

    const handleSubmissionVersionPopupVisibilityChange = async () => {
        if (!versionsShouldBeFetched) setVersionsShouldBeFetched(true)
    }

    const handleSubmissionVersionChange = versionId => {
        dispatch(submissionActions.setSelectedVersionId(versionId))
    }

    const submissionVersionOptions = submissionVersions?.map(version => {
        return {
            label: (
                <Space>
                    {isSenseUser && version.studentFeedback?.liked !== undefined &&
                        (version.studentFeedback.liked ? (
                            <LikeOutlined style={{ color: successColor }} />
                        ) : (
                            <DislikeOutlined style={{ color: errorColor }} />
                        ))
                    }
                    {sqlToJsDate(version.id)}
                </Space>
            ),
            value: version.id,
                description: isSenseUser ? version.studentFeedback?.comment : null,
        }
    })

    return (
        <label>
            <Text type='secondary' className='mr-4'>
                Version
            </Text>
            <Select
                popupMatchSelectWidth={false}
                value={selectedVersionId}
                loading={isFetchingSubmissionVersions}
                options={submissionVersionOptions}
                onChange={handleSubmissionVersionChange}
                onDropdownVisibleChange={handleSubmissionVersionPopupVisibilityChange}
                getPopupContainer={() => document.getElementById('editor-container')}
                style={{ minWidth: '300px' }}
                optionRender={renderOptionWithDescription}
                showSearch
                optionFilterProp='label'
            />
            {errorFetchingSubmissionVersions && (
                <Alert message={errorFetchingSubmissionVersions} type='error' showIcon closable />
            )}
        </label>
    )
}

export default SubmissionVersionSelector
